import React, { useState, useEffect, useCallback } from 'react';
import { AppBar, Toolbar, Button, Box, Tabs, Tab, IconButton, Divider, Drawer, List, ListItem, ListItemText, useMediaQuery, useTheme } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { TbLogout } from "react-icons/tb";

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'https://www.verbalyze.in/login';

const Navbar = ({ onThemeChange }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const clearAuthData = useCallback(() => {
    // Clear all authentication-related data
    localStorage.removeItem("token");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userId");
    // Add any other auth-related items to remove
    sessionStorage.clear(); // Clear any session storage data
  }, []);
  const [dashboardValue, setDashboardValue] = useState(0);
  const [settingsValue, setSettingsValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  

  const toggleDarkMode = () => {
    onThemeChange((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const isDashboardRoute = ['/dashboard', '/dashboard/call-logs', '/dashboard/call-analytics'].some(route => location.pathname.startsWith(route));
  const isAIAgentsRoute = ['/ai-agents'].some(route => location.pathname.startsWith(route));
  const isSettingsRoute = ['/bill-and-payment', '/user-management', '/profile-settings', '/integration-setup'].some(route => location.pathname.startsWith(route));

  useEffect(() => {
    if (isDashboardRoute) {
      setDashboardValue(
        location.pathname === '/dashboard' ? 0 :
        location.pathname === '/dashboard/call-logs' ? 1 :
        location.pathname === '/dashboard/call-analytics' ? 2 : 0
      );
    }

    if (isSettingsRoute) {
      setSettingsValue(
        location.pathname === '/bill-and-payment' ? 0 :
        location.pathname === '/profile-settings' ? 1 :
        location.pathname === '/integration-setup' ? 2 :
        location.pathname === '/user-management' ? 3 : 0
      );
    }
  }, [location.pathname, isDashboardRoute, isAIAgentsRoute, isSettingsRoute]);

  const menuItems = [
    { text: 'Dashboard', link: '/dashboard' },
    { text: 'AI Agents', link: '/ai-agents' },
    { text: 'Resources', link: '/resources' },
    { text: 'Account', link: '/bill-and-payment' },
  ];

  const drawer = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {menuItems.map((item) => (
          <ListItem button key={item.text} component={Link} to={item.link}>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider />
  
    </Box>
  );

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    window.location.href = LOGIN_URL;
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar sx={{ 
          justifyContent: 'space-between', 
          padding: '0 !important', 
          minHeight: '64px',
          '&.MuiToolbar-root': {
            paddingLeft: '0',
            paddingRight: '0'
          }
        }}>
          <div style={{ display: 'flex', alignItems: 'center', flexGrow: 0, paddingLeft: '8px' }}>
            <img 
              src={`${process.env.PUBLIC_URL}/images/Verb_White_logo.png`} 
              alt="Verbalyze Logo" 
              style={{ height: '40px', marginRight: '20px' }} 
            />
          </div>
          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'flex-end' }}>
              {menuItems.map((item, index) => (
                <React.Fragment key={item.text}>
                  <Button 
                    color="inherit" 
                    component={Link} 
                    to={item.link} 
                    sx={{ 
                      fontSize: '1.1rem',
                      fontWeight: location.pathname.startsWith(item.link) ? 'bold' : 'normal',
                    }}
                  >
                    {item.text}
                  </Button>
                  {index < menuItems.length - 1 && (
                    <Divider orientation="vertical" flexItem sx={{ mx: 1, my: 1 }} />
                  )}
                </React.Fragment>
              ))}
{/*             <button onClick={toggleDarkMode} className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-8 w-8 group rounded-lg border-none bg-transparent shadow-lg hover:bg-blue-700/5"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-moon absolute size-5 transition-all ${theme.palette.mode === 'dark' ? 'rotate-0 scale-100 text-white' : 'rotate-90 scale-0 group-hover:text-blue-500'}`}><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path></svg><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`lucide lucide-sun size-5 transition-all ${theme.palette.mode === 'dark' ? 'rotate-90 scale-0 text-black' : 'rotate-0 scale-100 text-white'}`}><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2"></path><path d="M12 20v2"></path><path d="m4.93 4.93 1.41 1.41"></path><path d="m17.66 17.66 1.41 1.41"></path><path d="M2 12h2"></path><path d="M20 12h2"></path><path d="m6.34 17.66-1.41 1.41"></path><path d="m19.07 4.93-1.41 1.41"></path></svg><span className="sr-only">DarkMode Toggle</span></button>
will be used later */}            <div
              onClick={handleLogout}
              className="text-3xl flex items-center ml-3 mt-1 text-red-500 hover:text-red-700 cursor-pointer"
            >
              <TbLogout />
            </div>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* This empty Toolbar acts as a spacer */}

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        {drawer}
      </Drawer>
      {isDashboardRoute && (
        <AppBar position="sticky" color="default" sx={{ top: 64, zIndex: theme.zIndex.appBar - 1, overflowX: 'auto' }}>
          <Tabs
            value={dashboardValue}
            onChange={(event, newValue) => setDashboardValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant={isMobile ? "scrollable" : "fullWidth"}
            scrollButtons="auto"
          >
            <Tab label="Overview" component={Link} to="/dashboard" />
            <Tab label="Call Logs" component={Link} to="/dashboard/call-logs" />
            <Tab label="Call Analytics" component={Link} to="/dashboard/call-analytics" />
          </Tabs>
        </AppBar>
      )}

      {isSettingsRoute && (
        <AppBar position="sticky" color="default" sx={{ top: 64, zIndex: theme.zIndex.appBar - 1, overflowX: 'auto' }}>
          <Tabs
            value={settingsValue}
            onChange={(event, newValue) => setSettingsValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant={isMobile ? "scrollable" : "fullWidth"}
            scrollButtons="auto"
          >
              <Tab label="Billing" component={Link} to="/bill-and-payment" />
            <Tab label="Profile" component={Link} to="/profile-settings" />
            <Tab label="Integration Setup" component={Link} to="/integration-setup" />
{/*             <Tab label="User Management" component={Link} to="/user-management" /> // TO DO
 */}          </Tabs>
        </AppBar>
      )}
       {/*<div style={{ marginTop: '14px' }} /> Spacer to prevent content overlap */}
    </>
  );
};

export default Navbar;
